import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Tienes 45 o más y el sueño ya no es lo que era', 'Tu mente no para aunque tu cuerpo esté agotada', 'Te despiertas a las 3AM con ansiedad o miedo', 'Ya probaste pastillas, tés o meditaciones — y no fue suficiente', 'No tienes tiempo ni dinero para soluciones complicadas', 'Quieres algo práctico, mexicano, que funcione esta noche'];
  const notForYou = ['Buscas una solución mágica sin ningún esfuerzo', 'No estás dispuesta a cambiar aunque sea 15 minutos de tu noche', 'Tienes un trastorno de sueño grave diagnosticado que requiere tratamiento médico especializado'];
  return <section className="py-20 px-4 md:px-8 bg-cream-100 text-navy-900" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <div className="text-center mb-16" data-id="element-135">
          <span className="text-4xl mb-4 block" data-id="element-136">🎯</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-137">
            SECCIÓN 6 — PARA QUIÉN ES
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-138">
            (Y PARA QUIÉN NO)
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-139">
          {/* For You */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-140">
            <h4 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-3" data-id="element-141">
              <Check className="h-8 w-8" data-id="element-142" />
              Esta guía es para ti si...
            </h4>
            <ul className="space-y-4" data-id="element-143">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
                  <div className="bg-green-100 p-1 rounded-full mt-1" data-id="element-145">
                    <Check className="h-4 w-4 text-green-600" data-id="element-146" />
                  </div>
                  <span className="text-navy-800 text-lg" data-id="element-147">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-500" data-id="element-148">
            <h4 className="text-2xl font-bold text-red-700 mb-6 flex items-center gap-3" data-id="element-149">
              <X className="h-8 w-8" data-id="element-150" />
              Esta guía NO es para ti si...
            </h4>
            <ul className="space-y-4" data-id="element-151">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-152">
                  <div className="bg-red-100 p-1 rounded-full mt-1" data-id="element-153">
                    <X className="h-4 w-4 text-red-600" data-id="element-154" />
                  </div>
                  <span className="text-navy-800 text-lg" data-id="element-155">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}